module.exports = __webpack_public_path__ + "img/icon_charge_un.a60ce816.png";